var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisableToggleOffIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "33px",
    height: "17px",
    viewBox: "0 0 33 17",
    style: {
      enableBackground: "new 0 0 33 17"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E64B38;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,2.7C29.1,1,26.9,0,24.5,0H8.9C8.8,0,8.7,0,8.7,0C8.6,0,8.6,0,8.5,0C3.8,0,0,3.8,0,8.5S3.8,17,8.5,17 c0,0,0,0,0,0c0,0,0,0,0,0h15.7c4.7,0,8.5-3.5,8.8-8C33.2,6.7,32.3,4.4,30.7,2.7z M8.5,16c-2.1,0-4-0.8-5.4-2.3 C1.7,12.1,1,10.1,1.1,8c0.2-3.9,3.5-6.9,7.6-7c4,0.1,7.3,3.4,7.3,7.5C16,12.6,12.6,15.9,8.5,16z M32,9c-0.2,3.9-3.6,7-7.8,7H12.6 c2.6-1.4,4.4-4.2,4.4-7.5s-1.8-6-4.4-7.5h12c2.1,0,4,0.8,5.4,2.3C31.4,4.9,32.1,6.9,32,9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.5,5.8c-0.2-0.2-0.5-0.2-0.7,0l-2.2,2.2l-2.2-2.2c-0.2-0.2-0.5-0.2-0.7,0c-0.2,0.2-0.2,0.5,0,0.7l2.2,2.2 l-2.2,2.2c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.2,0.4,0.2s0.3-0.1,0.4-0.2l2.2-2.2l2.2,2.2c0.1,0.1,0.2,0.2,0.4,0.2 s0.3-0.1,0.4-0.2c0.2-0.2,0.2-0.5,0-0.7l-2.2-2.2l2.2-2.2C26.7,6.3,26.7,6,26.5,5.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableToggleOffIcon);
export default __webpack_public_path__ + "static/media/disable-toggle-off-icon.fec1cab6673a75c44eeaa627e707584d.svg";
export { ForwardRef as ReactComponent };